<template>
    <section class="section federations is-full-height-with-navbar">
        <FederationsListing />

        <FederationCreateModal ref="federationCreateModal" />
    </section>
</template>

<script setup lang="ts">
    import { onMounted, ref } from "vue";
    import FederationsListing from "./Listing/FederationsListing.vue";
    import { useFederationStore } from "./Listing/federationStore";
    import FederationCreateModal from "./Listing/FederationCreateModal.vue";
    import { eventBus, OPEN_FEDERATION_CREATE_MODAL } from "./eventBus";
    import { ComponentExposed } from "vue-component-type-helpers";
    import { useScrollResetOnMount } from "../Common/useScrollResetOnMount";

    useScrollResetOnMount();

    const props = defineProps<{
        userId: number;
    }>();

    const federationStore = useFederationStore();
    federationStore.userId = props.userId;

    const federationCreateModal = ref<ComponentExposed<typeof FederationCreateModal> | null>(null);

    onMounted(() => {
        eventBus.$on(OPEN_FEDERATION_CREATE_MODAL, () => {
            federationCreateModal.value?.open();
        });
    });
</script>

<style scoped></style>
